import { captureAuthCallbackParams } from '@/Domain/utils/authCallbackParams';
import { stripLegacyBodyCredentials } from '@/Domain/utils/legacyBodyCredentials';
import {
  clearPendingVerificationEmailOnActivation,
  consumePendingVerificationEmailFromUrl,
} from '@/Domain/utils/pendingVerificationEmail';

stripLegacyBodyCredentials();
consumePendingVerificationEmailFromUrl();
clearPendingVerificationEmailOnActivation();
captureAuthCallbackParams();
